/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import {
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard,
  TopicLanguageNotSupportedGuard,
  TopicNotSelectedGuard,
  UnexpectedServiceErrorGuard,
  WidgetLoadingGuard
} from 'components/widget/share/guards'
import { WidgetGuard } from 'features/types'
import RunSearchEffect from '../RunSearchEffect'
import TrendingEmptyResultGuard from './TrendingWidgetsEmptyResultGuard'
import TrendingWidgetBelowThresholdGuard from './TrendingWidgetBelowThresholdGuard'

const TrendingWidgetDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <TopicNotSelectedGuard widgetId={widgetId}>
    <RunSearchEffect widgetId={widgetId}>
      <WidgetLoadingGuard widgetId={widgetId}>
        <TopicInaccessibleGuard widgetId={widgetId}>
          <UnexpectedServiceErrorGuard widgetId={widgetId}>
            <TopicIndexNotReadyGuard widgetId={widgetId}>
              <TopicLanguageNotSupportedGuard widgetId={widgetId}>
                <TrendingEmptyResultGuard widgetId={widgetId}>
                  <TrendingWidgetBelowThresholdGuard widgetId={widgetId}>
                    {children}
                  </TrendingWidgetBelowThresholdGuard>
                </TrendingEmptyResultGuard>
              </TopicLanguageNotSupportedGuard>
            </TopicIndexNotReadyGuard>
          </UnexpectedServiceErrorGuard>
        </TopicInaccessibleGuard>
      </WidgetLoadingGuard>
    </RunSearchEffect>
  </TopicNotSelectedGuard>
)

export default TrendingWidgetDataGuards
